import { Resource, globalAxios, QFood } from "@q-food/q-food";

export function useFormSubmit<T>(resource: Resource, resourceId?: string) {
	const submitSuccess = createEventHook<unknown>();
	const submitError = createEventHook<unknown>();

	async function submitForm<U = T>(params: {
		submitUrl?: string;
		data: U;
		method?: "post" | "put";
	}) {
		const submitUrl = params?.submitUrl?.replace(/\/$/, "") || resource.uri.replace(/\/$/, "");
		const submitAt = new URL(`${submitUrl}${resourceId ? `/${resourceId}` : ""}`, QFood.BASE_URL);

		const options = {
			headers: {
				"Content-Type": "application/json",
			},
		};
		const submitAsFormData = typeof params.data === "object" && params.data !== null && "files" in params.data;

		const formData = new FormData();
		if (submitAsFormData) {
			const { files, ...data } = params.data;
			for (const file of files as File[]) {
				formData.append("files", file);
			}
			formData.append("data", new Blob([JSON.stringify(data)], { type: "application/json" }));
			options.headers["Content-Type"] = "multipart/form-data";
			options.formSerializer = { indexes: null };
		}

		try {
			await globalAxios[params?.method || (resourceId ? "put" : "post")](
				submitAt.toString(),
				submitAsFormData ? formData : params.data,
				options,
			).then((res) => {
				submitSuccess.trigger(res);
			});
		} catch (e) {
			submitError.trigger(e);
		}
	}

	return {
		submitForm,
		onSubmitError: submitError.on,
		onSubmitSuccess: submitSuccess.on,
	};
}
